<template>
	<!-- USER PROFILE CARD 2 - MINIMAL -->
	<div class="vx-col w-full mb-base">
		<vx-card class="pr-4 pl-4" no-shadow card-border :title="resource_data.username">
			<template slot="actions">
				<div class="flex flex-row justify-between">
					<feather-icon
						:title="featuresOpen ? $t('MapModule.Minimize') : $t('MapModule.Maximize')"
						@click="toggleFeatures"
						:icon="featuresOpen ? 'Minimize2Icon' : 'Maximize2Icon'"
						:svgClasses="'h-4 w-4 stroke-current'"
					/>
				</div>
			</template>
			<div class="flex items-start sm:flex-col md:flex-row">
				<vs-avatar size="48px" :text="resource_data.username" :src="avatar" />
				<div class="ml-4">
					<p class="font-medium truncate">
						{{ fullName | capitalize }}
					</p>
					<p class="font-small">
						<small>{{ resource_data.email }}</small>
					</p>

					<div v-if="!featuresOpen">
						<feather-icon
							class="mr-4"
							:icon="resource_local.transmissionIcon"
							:svgClasses="transmissionColorIcon"
						/>
						<feather-icon
							class="mr-4"
							:icon="batteryLevelIcon.icon"
							:svgClasses="'h-8 w-8 stroke-current ' + batteryLevelIcon.color"
						/>
						<feather-icon class="mr-4 cursor-pointer" icon="Navigation2Icon" @click="LocateMarker" />
						<vs-icon
							class="mt-1"
							:icon="gpsIcon"
							size="small"
							:color="gpsIcon === 'gps_fixed' ? 'primary' : 'secondary'"
						></vs-icon>
						<tracking-info :tracking="{...tracking, username: resource_data.username}"></tracking-info>
					</div>
				</div>
			</div>
			<transition name="slide-fade">
				<geofence-zone v-if="isShownGeofence" :zoneList="dataZoneCarton" @isShowFeatures="isShowFeaturesEmit" />
				<div v-else>
					<div v-show-slide="featuresOpen">
						<!-- TRASNSMISION STATUS -->
						<div class="flex justify-between">
							<small class="flex items-center mb-1 mt-5 text-grey">
								{{ "Status" }}
							</small>
							<small class="flex items-center mb-1 mt-5 text-grey">
								{{ $t("MapModule.LastTransmission") }}
							</small>
						</div>
						<div class="flex justify-between">
							<span class="flex items-center">
								<feather-icon
									:icon="resource_local.transmissionIcon"
									:svgClasses="transmissionColorIcon"
								/>
								<span class="ml-2">{{ $t(`MapModule.${transmissionText}`) }}</span>
							</span>
							<span class="flex items-center">
								<span class="ml-2">{{ lastTransmission }}</span>
							</span>
						</div>
						<vs-divider />
						<!-- BATTERY LEVEL -->
						<div class="flex justify-between">
							<small class="flex items-center mb-1 mt-2 text-grey">
								{{ $t("Alarm.BatteryLevel") }}
							</small>
							<small class="flex items-center mb-1 mt-2 text-grey">
								{{ "GPS Status" }}
							</small>
						</div>
						<div class="flex justify-between">
							<span class="flex items-center">
								<feather-icon
									:icon="batteryLevelIcon.icon"
									:svgClasses="'h-8 w-8 stroke-current ' + batteryLevelIcon.color"
								/>
								<span class="ml-2">{{ tracking.battery }} %</span>
							</span>
							<span class="flex items-center">
								<vs-icon
									:icon="gpsIcon"
									size="small"
									:color="gpsIcon === 'gps_fixed' ? 'primary' : 'secondary'"
								></vs-icon>
								<span class="ml-2">{{ gpsIcon === "gps_fixed" ? "On" : "Off" }}</span>
							</span>
						</div>
						<div class="mb-4 vs-con-loading__container mt-base">
							<div class="flex justify-between">
								<small class="">{{ $t("Alarm.Speed") }}</small>
								<small class="font-semibold">{{ tracking.speed }} Km/h</small>
							</div>
							<vs-progress
								:indeterminate="indeterminateProgress"
								:percent="parseInt(tracking.speed)"
								class="block mt-1 shadow-md"
								color="success"
							></vs-progress>
						</div>
						<vs-divider />
						<p class="text-grey">{{ "Completed visit" }}</p>
						<div class="mb-1 vs-con-loading__container" id="progress-visit">
							<div class="flex justify-between">
								<small class="font-semibold">{{ resource_local.progress_done_per }}</small>
								<small class="text-success">{{ resource_local.progress_goal }}</small>
							</div>
							<vs-progress
								:indeterminate="indeterminateProgress"
								:percent="resource_local.current_progress"
								class="block mt-1 shadow-md"
								:color="currentProgressColor"
							></vs-progress>
						</div>
						<vs-divider />
						<div class="flex justify-center flex-wrap">
							<vx-tooltip
								class="cursor-pointer"
								style="z-index: 99999"
								:title="$t('MapModule.ScheduledRoute')"
								color="primary"
								position="bottom"
								:text="$t('MapModule.SeeDayScheduledRoute')"
							>
								<vs-button
									:id="routeBtnId"
									class="mr-2 vs-con-loading__container"
									color="primary"
									type="border"
									icon-pack="feather"
									icon="icon-git-pull-request"
									@click="programmedRoute"
								></vs-button>
							</vx-tooltip>
							<vx-tooltip
								class="cursor-pointer"
								style="z-index: 99999"
								:title="$t('MapModule.ExecutedRoute')"
								color="primary"
								position="bottom"
								:text="$t('MapModule.SeeDayExecutedRoute')"
							>
								<vs-button
									:id="executedRouteBtnId"
									class="mr-2 vs-con-loading__container"
									color="primary"
									type="border"
									icon-pack="feather"
									icon="icon-git-commit"
									@click="executedRoute"
								></vs-button>
							</vx-tooltip>
							<vx-tooltip
								class="cursor-pointer"
								style="z-index: 99999"
								:title="$t('MapModule.QuotesDay')"
								color="primary"
								position="bottom"
								:text="$t('MapModule.SeeListQuotesDay')"
							>
								<vs-button
									:id="scheduleBtnId"
									class="mr-2 vs-con-loading__container"
									type="border"
									color="primary"
									icon-pack="feather"
									icon="icon-calendar"
									@click="getEvents(resource_data.id)"
								></vs-button>
							</vx-tooltip>
							<vx-tooltip
								class="cursor-pointer"
								style="z-index: 99999"
								:title="$t('general.Geofence')"
								color="primary"
								position="top"
								:text="$t('View') + ' ' + $t('Alarm.AssignedZones')"
							>
								<vs-button
									:id="geofenceBtnId"
									class="vs-con-loading__container"
									type="border"
									color="primary"
									icon-pack="feather"
									icon="icon-layers"
									@click="getZonesAssignedToResource(resource_data.id)"
								></vs-button>
							</vx-tooltip>
						</div>
					</div>
				</div>
			</transition>
		</vx-card>
	</div>
</template>

<script>
import firebase from "firebase/app";
import DateUtils from "@/helpers/DateUtils.js";
import Commons from "@/helpers/commons.js";
import {generateInfowindowContentSchedule} from "./infowindowContent.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleResource from "@/store/resource/moduleResource.js";
import Tracking from "@/models/Tracking.js";
import mapMethods from "./mapMethods.js";
import Infowindow from "./Infowindow.vue";
import Vue from "vue";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import {addInfoBubble, addMarkerHereMap, centerHereMap, changeIconInMarkerHereMap} from "../../utils/HereMap";
import GeofenceZone from "./GeofenceZone";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import cartoDB from "@/helpers/cartoDB";
import cartodb from "@/constants/cartodb.js";
import TrackingInfo from "./TrackingInfo.vue";

let ComponentClass = Vue.extend(Infowindow);
const {cartoTable} = cartodb;

export default {
	name: "First",
	props: {
		resource: {
			type: Object,
		},
	},
	components: {GeofenceZone, Infowindow, TrackingInfo},
	data: () => ({
		instanceInfo: null,
		database: firebase.database(),
		tracking: new Tracking({}),
		resourceMarker: null,
		resource_local: {
			userImg: null, //require("@/assets/images/portrait/small/avatar-s-12.jpg"),
			name: "Zoila Legore",
			profession: "Backend Dev",
			btn_route_text: "Route",
			btn_schedule_text: "Schedule",
			batteryStatusIcon: "BatteryChargingIcon",
			batteryIcon: "BatteryIcon",
			footer_text_1: Math.floor(Math.random() * 100),
			transmissionIcon: "WifiIcon",
			isStarred: true,
			progress_done_per: 0,
			current_progress: 0,
			progress_goal: 0,
		},
		cardToggle: false,
		cardOpen: false,
		featuresOpen: false,
		backgroundLoading: "primary",
		colorLoading: "#fff",
		// Data for program route
		currentDay: new Date(),
		markerArray: [],
		possitionArray: [],
		// config loading button
		backgroundBtnLoading: "success",
		colorBtnLoading: "#fff",
		// propiedades para animaciondel marker
		currentPosition: {},
		numDeltas: 100,
		delay: 10, //milliseconds,
		i: 0,
		deltaLat: null,
		deltaLng: null,
		avatar: "",
		indeterminateProgress: false,
		dataZoneCarton: [],
		isShownGeofence: false,
	}),
	watch: {
		tracking(val) {
			if (this.resourceMarker) {
				this.changeMarkerPosition({lat: val.cy, lng: val.cx});
				this.changeMarkerColor();
				this.tracking.calculateHowLongLastTransmision();
				this.resource_data.battery = this.tracking.battery;
				this.resource_data.gps = this.tracking.gps;
				if (this.instanceInfo !== null) {
					this.instanceInfo.tracking = this.tracking;
				}
			}
		},
		lastTransmissionMinutes() {
			if (!this.resourceMarker) {
				return;
			}
			changeIconInMarkerHereMap(this.resourceMarker, mapMethods.generateMarkerIconResource(this.tracking));
		},
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	mounted() {
		this.getResourcePhoto();
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		const starCountRef = this.database.ref(
			"tracking/" + this.resource_data.company_id + "/" + this.resource_data.positionrecord_id
		);
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		starCountRef.once("value").then((snapshot) => {
			const resourceTracking = snapshot.val();
			if (resourceTracking && resourceTracking !== null) {
				this.$store.commit("moduleResource/UPDATE_RESOURCE", {
					...this.resource_data,
					tracking: resourceTracking,
				});
			}
		});

		starCountRef.on("value", (snapshot) => {
			const resourceTracking = snapshot.val();
			if (resourceTracking) {
				this.tracking = new Tracking(resourceTracking);
			}
		});
	},
	beforeDestroy() {
		if (this.resourceMarker) {
			this.resourceMarker.setData(null);
		}
	},
	computed: {
		photoURL() {
			return this.avatar;
		},
		routeBtnId() {
			return "btn-draw-programed-route-" + this.resource_data.id;
		},
		scheduleBtnId() {
			return "btn-show-schedule-" + this.resource_data.id;
		},
		executedRouteBtnId() {
			return "btn-draw-executed-route-" + this.resource_data.id;
		},
		geofenceBtnId() {
			return "btn-draw-geofence-" + this.resource_data.id;
		},
		resource_data() {
			return this.resource;
		},
		firtLetter() {
			return this.resource_data.name.substring(0, 1).toUpperCase();
		},
		batteryLevelIcon() {
			return this.tracking.getBatteryIcon();
		},
		lastTransmission() {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(this.tracking.date);
			mapMethods.howLongLastTransmission.call(this, this.tracking.date);
			return mapMethods.howLongLastTransmission.call(this, this.tracking.date); //DateUtils.relativeTime(newDate);
		},
		lastTransmissionMinutes() {
			return this.tracking.howLong;
		},
		gpsIcon() {
			return this.tracking.gps === "on" ? "gps_fixed" : "gps_off";
		},
		transmissionText() {
			return this.tracking.getTransmissionText();
		},
		transmissionColorIcon() {
			return this.tracking.getTransmissionColor();
		},
		fullName() {
			return this.resource_data.name + " " + this.resource_data.lastname;
		},
		dateInitComputed: {
			get() {
				return DateUtils.toDefaultDateTime(this.currentDay, "YYYY-MM-DD");
			},
		},
		currentProgressColor() {
			let percent = this.resource_local.current_progress;
			if (percent === 0) {
				return "primary";
			} else if (percent > 0 && percent < 25) {
				return "warning";
			} else if (percent >= 25 && percent < 75) {
				return "warning";
			} else {
				return "success";
			}
		},
	},
	methods: {
		isShowFeaturesEmit(val) {
			if (val) {
				this.isShownGeofence = false;
				this.featuresOpen = val;
			}
		},
		openLoadingInDivContent(idDivConten) {
			this.$vs.loading({
				container: idDivConten,
				background: this.backgroundBtnLoading,
				color: this.colorLoading,
				scale: 0.45,
			});
		},
		closeLoadingInDivContent(idDivConten) {
			this.$vs.loading.close(`${idDivConten} > .con-vs-loading`);
		},
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundBtnLoading,
				color: this.colorLoading,
				container: "#btn-with-loading",
				scale: 0.45,
			});
			setTimeout(() => {
				this.$vs.loading.close("#btn-with-loading > .con-vs-loading");
			}, 3000);
		},
		toggleFeatures() {
			this.calculateEventsProgress();
			this.featuresOpen = !this.featuresOpen;
			if (!this.featuresOpen) {
				this.resource_local.progress_done_per = 0;
				this.resource_local.current_progress = 0;
				this.resource_local.progress_goal = 0;
			}
		},
		toggleCard() {
			this.cardOpen = !this.cardOpen;
		},
		doSomething(val) {
			this.cardToggle = val;
		},
		closeCardAnimationDemo(card, eve) {
			card.removeRefreshAnimation(3000);
		},
		openExportPopup() {
			this.$emit("openExportPopupEmit");
		},
		async executedRoute() {
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resources_id: [this.resource_data.id],
				distance: 0.1,
			};
			Commons.openLoadingButton.call(this, this.executedRouteBtnId);
			try {
				const result = await this.$store.dispatch("moduleMap/getExecutedRoute", payload);
				Commons.closeLoadingButton.call(this, this.executedRouteBtnId);
				mapMethods.drawExecuteRoute.call(this, result.data, this.$store.state.moduleMap.optionsExecutedRoute);
			} catch (error) {
				Commons.closeLoadingButton.call(this, this.executedRouteBtnId);
				this.$vs.notify({
					color: "warning",
					title: this.$t("MapModule.GenerateRoute.Title"),
					text: this.$t("MapModule.GenerateRoute.Text"),
				});
				console.error(error);
			}
		},
		programmedRoute() {
			Commons.openLoadingButton.call(this, this.routeBtnId);
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resource_id: this.resource_data.id,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					Commons.closeLoadingButton.call(this, this.routeBtnId);
					mapMethods.drawProgramedRoute.call(
						this,
						res.data.records,
						this.$store.state.moduleMap.optionsProgramedRoute,
						true
					);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, this.routeBtnId);
					this.$vs.notify({
						color: "danger",
						title: this.$t("MapModule.ErrorGenerateAppointment.Title"),
						text: this.$t("MapModule.ErrorGenerateAppointment.Text"),
					});
					console.error(err);
				});
		},
		// Retorna un entero aleatorio entre min (incluido) y max (excluido)
		// ¡Usando Math.round() te dará una distribución no-uniforme!
		getRandomInt(min, max) {
			return Math.floor(Math.random() * (max - min)) + min;
		},
		addMarker(lat, lng) {
			this.currentPosition = {lat, lng};
			this.resource_data.battery = this.tracking.battery;
			this.resource_data.gps = this.tracking.gps;
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource(this.tracking),
				title: this.$t("MapModule.CurrentPosition"),
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: this.mountInfowindowComponent(),
				},
			};
			this.resourceMarker = addMarkerHereMap(lat, lng, options, true);
			addInfoBubble(this.resourceMarker, options.infoWindow.content);
		},
		cleanInfowindow() {
			if (this.instanceInfo !== null) {
				this.instanceInfo.$destroy();
				this.instanceInfo = null;
			}
		},
		mountInfowindowComponent() {
			this.cleanInfowindow();
			if (this.instanceInfo) {
				this.instanceInfo.$destroy();
				this.instanceInfo = null;
			}
			this.instanceInfo = new ComponentClass({
				propsData: {
					resourceData: this.resource_data,
					tracking: this.tracking,
				},
			});
			this.instanceInfo.$mount();
			return this.instanceInfo.$el;
		},
		addMarkerRoute(lat, lng, infoWindowData) {
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconEvent(infoWindowData.event_status_id), //this.generateMarkerIconEvent(infoWindowData.event_status_id),
				title: this.$t("MapModule.CurrentPosition"),
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: generateInfowindowContentSchedule(infoWindowData),
				},
				infoLatLng: {lat, lng},
			};
			let newMarker = addMarkerHereMap(lat, lng, options, true);
			this.possitionArray.push({lat, lng});
			this.markerArray.push(newMarker);
		},
		changeMarkerPosition(newPosition) {
			this.transition(newPosition);
		},
		changeMarkerColor() {
			const newIconMarker = mapMethods.generateMarkerIconResource(this.tracking);
			changeIconInMarkerHereMap(this.resourceMarker, newIconMarker);
		},
		capitalize(value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
		toggleMapSidebar(val = false) {
			this.$store.dispatch("moduleMap/changeToggleMapSidebar", val);
		},
		getEvents(resource_id) {
			Commons.openLoadingButton.call(this, this.scheduleBtnId);
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resource_id: resource_id,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					setTimeout(() => {
						this.openExportPopup();
					}, 500);
					Commons.closeLoadingButton.call(this, this.scheduleBtnId);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, this.scheduleBtnId);
					console.error(err);
				});
		},
		getZonesAssignedToResource(resourceId) {
			Commons.openLoadingButton.call(this, this.geofenceBtnId);
			let zonesResource = [];
			this.dataZoneCarton = [];
			this.$store
				.dispatch("moduleZonification/assignedZoneResourceById", resourceId)
				.then((res) => {
					if (res) {
						zonesResource = res.map(({zone_id}) => zone_id);
						cartoDB
							.executeQueryWithBounds(
								`SELECT * FROM ${cartoTable} WHERE cartodb_id IN (${zonesResource.join(",")})`
							)
							.then((res) => {
								if (res) {
									this.isShownGeofence = !this.isShownGeofence;
									for (let item of res.data.features) {
										this.dataZoneCarton.push({
											resource_id: resourceId,
											zone_id: item.properties.cartodb_id,
											name: item.properties.name,
											disabled: false,
										});
									}
								} else {
									this.dataZoneCarton = [];
									this.isShownGeofence = false;
									return;
								}
							})
							.catch((err) => {
								Commons.closeLoadingButton.call(this, this.geofenceBtnId);
								this.isShownGeofence = false;
								this.dataZoneCarton = [];
								console.error(err);
							});
					} else {
						throw {err: "no found zones"};
					}
					Commons.closeLoadingButton.call(this, this.geofenceBtnId);
				})
				.catch((err) => {
					if (err.err === "no found zones") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("Information"),
							text: this.$t("general.NoZonesAssigned"),
							time: 4000,
						});
					}
					this.isShownGeofence = false;
					Commons.closeLoadingButton.call(this, this.geofenceBtnId);
					console.error(err);
				});
		},
		transition(newPosition) {
			this.i = 0;
			this.deltaLat = (newPosition.lat - this.currentPosition.lat) / this.numDeltas;
			this.deltaLng = (newPosition.lng - this.currentPosition.lng) / this.numDeltas;
			this.moveMarker();
		},
		moveMarker() {
			this.currentPosition.lat += this.deltaLat;
			this.currentPosition.lng += this.deltaLng;
			if (isNaN(this.currentPosition.lat)) return;
			this.resourceMarker.setGeometry({
				lat: this.currentPosition.lat,
				lng: this.currentPosition.lng,
			});
			// centerHereMap(this.currentPosition.lat, this.currentPosition.lng, null);
			if (this.i != this.numDeltas) {
				this.i++;
				setTimeout(this.moveMarker, this.delay);
			}
		},
		calculateEventsProgress() {
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resource_id: this.resource_data.id,
			};
			this.indeterminateProgress = true;
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					this.indeterminateProgress = false;
					if (res.data.records) {
						this.resource_local.progress_goal = res.data.records.length;
						const progress = res.data.records.filter((element) => element.event_status_id === 7);
						this.resource_local.progress_done_per = progress.length;
						this.resource_local.current_progress =
							(progress.length * 100) / this.resource_local.progress_goal;
					}
				})
				.catch((err) => {
					this.indeterminateProgress = false;
					console.error(err);
				});
		},
		getResourcePhoto() {
			const url = this.resource_data.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		LocateMarker() {
			const lat = parseFloat(this.tracking.cy);
			const lng = parseFloat(this.tracking.cx);
			if (!Number.isNaN(lat)) {
				centerHereMap(lat, lng, {zoom: 18});
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Error"),
					text: this.$t("MapModule.NoLocate"),
					time: 4000,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-avatar {
	span {
		font-size: 55px;
	}
}

.infowindow-avatar {
	width: 100px;
	border-radius: 50%;
}

.cursor-pointer {
	cursor: pointer;
}

.margin-less {
	margin-right: -15px;
}

.infowindow-avatar {
	display: flex;
	justify-content: space-around;
	width: auto;
	align-items: center;
}

.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
	transform: translateX(200px);
	opacity: 0;
}
</style>
